<template>
  <nav class="navbar fixed-top">
    <div class="container-fluid d-flex justify-content-between align-items-center">
      <div class="navbar-header">
        <h3 class="navbar-brand">
          <b>AlliKamay</b>
        </h3>
      </div>

      <!-- Botón hamburguesa -->
      <div class="d-flex align-items-center">
        <div class="user-name text-white">{{ usuario }}</div>
        <button
          class="navbar-toggler ms-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
        >
          <i class="material-icons">menu</i>
        </button>
      </div>

      <!-- Menú lateral -->
      <div
              class="offcanvas offcanvas-end"
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
      >
        <!-- Header con usuario -->
        <div class="offcanvas-header">
          <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
          ></button>
        </div>

        <div class="offcanvas-header">
          <div class="container-fluid d-flex flex-column">
            <span class="navbar-brand mb-0 text-primary fw-bold">{{ usuario }}</span>
            <span class="text-muted small">{{ perfil }}</span>
          </div>
        </div>

        <!-- Opciones de usuario -->
        <div class="offcanvas-body">
          <ul class="navbar-nav">
            <router-link class="nav-link" to="/actualizarclave">
              Cambio de Clave
            </router-link>
            <li class="nav-link clickable" @click="logout('changeUser')">
              Cambio de Usuario
            </li>
          </ul>
        </div>

        <!-- Menú de utilidades -->
        <div class="offcanvas-body">
          <ul class="navbar-nav">
            <router-link class="nav-link" to="/consultacobertura">
              Consulta Cobertura
            </router-link>
            <router-link class="nav-link" to="/vademecum">
              Vademecum
            </router-link>
            <router-link class="nav-link" to="/calculadora">
              Calculadora
            </router-link>
            <router-link class="nav-link" to="/imc-adultos">
              IMC Adultos
            </router-link>
            <router-link class="nav-link" to="/imc-menores">
              IMC Menores
            </router-link>
          </ul>
        </div>

        <!-- Botón cerrar sesión -->
        <div class="nav-item logout-button p-3">
          <button class="btn btn-danger w-100 d-flex align-items-center justify-content-center gap-2" @click="logout('logout')">
            <i class="material-icons">power_settings_new</i>
            Cerrar Sesión
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "Navbar",
    props: {
      usuario: String,
      perfil: String,
      modulo: Number,
    },
    methods: {
      logout(action) {
        this.$emit("logout", action);
      },
    },
  };
</script>

<style src="@/assets/css/navbar.css" scoped></style>
<style scoped>
  .clickable {
    cursor: pointer;
  }
  .navbar-brand {
    font-size: 1.5rem;
    font-weight: 600;
  }
  .text-muted.small {
    font-size: 0.875rem;
  }
</style>
